module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/customers.json
// module id = 1996
// module chunks = 63946074332492